const setting = () => import('@/page/settings/setting')
const settingAccount = () => import('@/page/settings/account')
const settingAvatar = () => import('@/page/settings/avatar')
const settingPwd = () => import('@/page/settings/password')
const settingPhone = () => import('@/page/settings/phone')
const settingPop = () => import('@/page/settings/pop')
const settingBase = () => import('@/page/settings/base')
const settingAgency = () => import('@/page/settings/agency')
const settingFilter = () => import('@/page/settings/filter')
const autoforward = () => import('@/page/settings/autoforward')
const managefolder = () => import('@/page/settings/managefolder')
const whitelist = () => import('@/page/settings/whitelist')
const blacklist = () => import('@/page/settings/blacklist')
const signature = () => import('@/page/settings/signature')
const autoreply = () => import('@/page/settings/autoreply')
const skin = () => import('@/page/settings/skin')
const settingRouter = {
    path: 'setting',
    name: 'setting',
    component: setting,
    children: [{
        path: 'account',
        name: 'settingAccount',
        component: settingAccount
    }, {
        path: 'account/pwd',
        name: 'settingPwd',
        component: settingPwd
    }, {
        path: 'account/phone',
        name: 'settingPhone',
        component: settingPhone
    }, {
        path: 'account/avatar',
        name: 'settingAvatar',
        component: settingAvatar
    }, {
        path: 'pop',
        name: 'settingPop',
        component: settingPop
    }, {
        path: 'base',
        name: 'settingBase',
        component: settingBase
    }, {
        path: 'agency',
        name: 'settingAgency',
        component: settingAgency
    }, {
        path: 'autoforward',
        name: 'autoforward',
        component: autoforward
    }, {
        path: 'signature',
        name: 'signature',
        component: signature
    }, {
        path: 'autoreply',
        name: 'autoreply',
        component: autoreply
    }, {
        path: 'managefolder',
        name: 'managefolder',
        component: managefolder
    }, {
        path: 'filter',
        name: 'settingFilter',
        component: settingFilter
    }, {
        path: 'whitelist',
        name: 'whitelist',
        component: whitelist
    }, {
        path: 'blacklist',
        name: 'blacklist',
        component: blacklist
    }, {
        path: 'skin',
        name: 'skin',
        component: skin
    }, {
        path: '/setting*',
        redirect: 'account'
    }]
}

export default settingRouter 


// WEBPACK FOOTER //
// ./src/router/setting.js